// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__V9rLH","clinicsSelect":"styles_clinicsSelect__3laO5"};